import { FormatSpecifier as FormatSpecifier_internal } from "./FormatSpecifier";
var IgrFormatSpecifier = /** @class */ /*@__PURE__*/ (function () {
    function IgrFormatSpecifier() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrFormatSpecifier.prototype.createImplementation = function () {
        return new FormatSpecifier_internal();
    };
    Object.defineProperty(IgrFormatSpecifier.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrFormatSpecifier.prototype.onImplementationCreated = function () {
    };
    IgrFormatSpecifier.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    IgrFormatSpecifier.prototype.findByName = function (name) {
        return null;
    };
    return IgrFormatSpecifier;
}());
export { IgrFormatSpecifier };
//# sourceMappingURL=igr-format-specifier.js.map
